import React from 'react';
import './Footer.css'
const Footer = () => {
    return (
        <div className="footer">
            <p>© 2021 galib All Rights Reserved</p>
        </div>
    );
};

export default Footer;